import { toast } from "@/components/ui/use-toast"

// Shared id for the deductions / transactions table container on the deductions
// and accounting pages. Charts scroll the user here after activating a filter so
// it's clear the filter was applied and where to look for the results.
export const FILTERED_TABLE_ANCHOR_ID = "filtered-table-anchor"

// Called when a chart (BarList) activates a filter on the deductions or accounting
// table. Gives the user feedback on what happened via a toast and scrolls them down
// to the filtered table so it's obvious the filter was activated.
export function notifyChartFilterApplied(description: string) {
  toast({
    title: "Filter applied",
    description,
  })
  scrollToFilteredTable()
}

// Called when a chart selection clears the filters (e.g. "show all").
export function notifyChartFilterCleared(description: string) {
  toast({
    title: "Filter cleared",
    description,
  })
  scrollToFilteredTable()
}

function scrollToFilteredTable() {
  // The anchor is always in the DOM and sits above the filtered rows, so its
  // position is stable regardless of the new filter — no need to wait for the
  // table to re-render before scrolling.
  const el = document.getElementById(FILTERED_TABLE_ANCHOR_ID)
  el?.scrollIntoView({ behavior: "smooth", block: "start" })
}
